import { render, staticRenderFns } from "./AdvicesArticle.vue?vue&type=template&id=538fadac&"
import script from "./AdvicesArticle.vue?vue&type=script&lang=js&"
export * from "./AdvicesArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports